import { Box, Typography } from "@mui/material";
import BlogBanner from "../../components/website/blog/BlogBanner";
import BlogList from "../../components/website/blog/BlogList";
import styles from "./BlogPage.module.scss";
import useScrollToHash from "../../helpers/useScrollToHash";

const BlogPage = () => {
  useScrollToHash({ targetSection: "blog-page" });
  return (
    <>
      <BlogBanner />
      <br id="blog-page" />
      <Box className={styles.blogIntro}>
        <Typography variant="h1" className={styles.heading}>
          Insights & Updates from Bidding Karo
        </Typography>

        <Typography variant="body1" className={styles.description}>
          Practical guides, bidding strategies, and industry insights to help
          buyers and suppliers make smarter decisions.
        </Typography>
      </Box>

      <BlogList />
    </>
  );
};

export default BlogPage;
